import type { ComputedRef, InjectionKey } from "vue";
import type { ControlsDesignVersion, DesignVersion } from "./types";

export const DESIGN_VERSION: InjectionKey<ComputedRef<DesignVersion>> =
  Symbol("DESIGN_VERSION");
export const CONTROLS_DESIGN_VERSION: InjectionKey<ComputedRef<ControlsDesignVersion>> =
  Symbol("CONTROLS_DESIGN_VERSION");

export const DEFAULT_DESIGN_VERSION: DesignVersion = "7new";
export const DEFAULT_CONTROLS_DESIGN_VERSION: ControlsDesignVersion = "7";
